import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren {
  size?: '2x' | '1x' | 'sm' | 'no-margin';
  backgroundColor?: string;
  biggerBackground?: boolean;
  stackOnly?: boolean;
  isLarge?: boolean;
}

export class IconWithBackground extends React.Component<IProps, {}> {
  render() {
    const { children, size, backgroundColor, biggerBackground, stackOnly, isLarge } = this.props;

    return (
      <span
        className="fa-stack"
        style={
          isLarge
            ? { height: '1.25em', width: '1.1em' }
            : size === 'sm'
              ? { height: '0.7em', width: '1.4em' }
              : size === 'no-margin'
                ? { height: '1em', width: '1.25em' }
                : undefined
        }
      >
        {!stackOnly && (
          <FontAwesomeIcon
            icon={faCircle}
            className={`fa-stack-${(size === 'sm' ? '1x' : size) || '1x'} icon-background`}
            color={backgroundColor || 'white'}
            style={{
              ...(biggerBackground ? { zoom: '1.15' } : {}),
            }}
          />
        )}
        {children}
      </span>
    );
  }
}
